import React, { Component } from 'react';
import { Button, Modal, Dropdown } from 'semantic-ui-react'

class ShareModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      managers: this.props.managers,
      options: this.generateOptions()
    }

    this.generateOptions = this.generateOptions.bind(this)
    this.onManagerChange = this.onManagerChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  generateOptions(){
    var options = []
    this.props.users.map(function(user, index){
      options = options.concat({
        key: user.id,
        text: user.details,
        value: user.id
      })
      return true
    })
    return options
  }

  onManagerChange(e, { value }) {
    //if value is empty make sure that the user's id is retained atleast
    this.setState({
      managers: value.length === 0 ? [this.props.user.id] : value
    })
  }

  onSave(evt){
    this.props.updateMatrix({ managers: this.state.managers, id: this.props.tagId, userId: this.props.user.id })
    this.props.onClose()
  }

  render() {
    const { onClose, show } = this.props
    const { options, managers } = this.state
    return (
      <Modal size={ 'mini' } dimmer={ 'inverted' } open={ show } className='share-modal'>
        <Modal.Header>Share to Managers</Modal.Header>
        <Modal.Content>
          <label>Current Managers</label>
          <Dropdown
            ref='managers'
            fluid
            selection
            multiple={true}
            search={true}
            options={options}
            value={managers}
            placeholder='Add manager'
            onChange={this.onManagerChange}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            content="Cancel"
            onClick={() => onClose()}
          />
          <Button
            positive
            content="Save"
            onClick={this.onSave}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ShareModal;



// WEBPACK FOOTER //
// ./src/views/components/modals/share.js